var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "44",
        height: "45",
        viewBox: "0 0 44 45",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M31 22.95L16.75 31.1773V14.7228L31 22.95Z",
          stroke: "white",
          "stroke-width": "2",
        },
      }),
      _vm._v(" "),
      _c("circle", {
        attrs: {
          cx: "22",
          cy: "22.45",
          r: "21",
          stroke: "white",
          "stroke-width": "2",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./resources/js/Components/Youtube/PlayIcon.vue